import { patchedStoryblokEditable } from 'apps/urban/utils/patchedStoryblokEditable';

import { TagWrapper } from './HeroTagBullet.style';
import { THeroTagBulletProps } from './HeroTagBullet.types';

export const HeroTagBullet = ({ blok, blok: { title } }: THeroTagBulletProps) => (
  <div {...patchedStoryblokEditable(blok)}>{title && <TagWrapper>{title}</TagWrapper>}</div>
);
